import { AxiosResponse } from 'axios';

import { get, post } from 'services/api';

import { ILoginFormData } from 'views/LoginView/types';
import { IRegisterFormData } from 'views/RegisterView/types';

export const initialize = (): Promise<AxiosResponse> => get('auth/profile');

export const login = (formData: ILoginFormData): Promise<AxiosResponse> =>
  post('auth/login', formData);

export const loginPublic = (formData: ILoginFormData): Promise<AxiosResponse> =>
  post('auth/login-public', formData);

export const logout = (): Promise<AxiosResponse> => get('auth/logout');

export const registerPublic = (formData: IRegisterFormData): Promise<AxiosResponse> =>
  post('auth/register-public', formData);
